import {
  CASEALERT_MARKREAD,
  RECEIVE_CASE_ALERTS,
} from "typeConstants";
import { caseAlerts as initialState } from "reducers/initialState.tsx";

const caseAlerts = (state = initialState, action) => {
  switch (action.type) {
    case CASEALERT_MARKREAD:
      return state.map(caseAlert => {
        if (caseAlert.id === action.payload)
          return { ...caseAlert, isNew: false };
        return caseAlert;
      });
    case RECEIVE_CASE_ALERTS:
      return [
        ...action.payload.filter(incomingCaseAlert => {
          if (!state.length)
            return true;
          return !(state.some(preexistingCaseAlert =>
            preexistingCaseAlert.id === incomingCaseAlert.id
          ));
        }).map(incomingCaseAlert => {
          return {
            ...incomingCaseAlert,
            isNew: true
          };
        }),
        ...state.filter(preexistingCaseAlert =>
          action.payload.some(incomingCaseAlert =>
            incomingCaseAlert.id === preexistingCaseAlert.id
          )
        ),
      ];
    default:
      return state;
  }
};

export default caseAlerts;
